import { createAction } from '@reduxjs/toolkit';

export const logoutSuccess = createAction('LOGOUT_SUCCESS');
